module.exports = __webpack_public_path__ + "img/logo.a1323d6c.png";